import { RPMedia } from '@pages/Explore/components/RPModal/components/RPMediaCarousel/components/RPMedia';
import { Carousel, Empty } from 'antd';
import { IMedia } from 'interface/medias';

export type RPMediaCarouselProps = {
  rpMedias: IMedia[];
};

const RPMediaCarousel: React.FC<RPMediaCarouselProps> = ({ rpMedias }) => {
  if (rpMedias.length === 0) return <Empty />;

  return (
    <Carousel autoplay={false}>
      {rpMedias.map((media) => (
        <RPMedia media={media} key={media.id} />
      ))}
    </Carousel>
  );
};

export default RPMediaCarousel;
